/**
 * Kontroll before the first working day (#294 ONB-12, owner's correction 2026-11-02): the clock beside
 * the heading, the text and two links stacked under it on the heading's edge. Nobody is late before the
 * work has begun, so nothing here says «mangler». Both links only navigate; neither completes a step.
 */
import { T } from '@/i18n';
import { dayMonth } from '@/ui/format';
import { Icon } from '@/ui/icons';
import { Link } from 'react-router-dom';

const GUIDE = 'https://timefly.no/hjelp/leder/timeliste-og-godkjenning.html';

export function Waiting({ start }: { start: string }) {
  return (
    <section className="kwait" data-testid="kontroll-waiting" aria-labelledby="kwait-h">
      <span className="kwait-ic" aria-hidden="true">
        <Icon name="clock" size={32} strokeWidth={1.8} />
      </span>
      <h2 id="kwait-h">{T('Vi venter på første arbeidsdag')}</h2>
      <p>
        {T('Dere starter {date}. Ingen timer er forsinket før arbeidet har begynt.', {
          date: dayMonth(start),
        })}
      </p>
      <div className="kwait-links">
        <a href={GUIDE} target="_blank" rel="noreferrer">
          {T('Slik registrerer dere tid')}
        </a>
        <Link to="/kom-i-gang">{T('Til Kom i gang')}</Link>
      </div>
    </section>
  );
}
